import AriaElement from '@vo/js/modules/AriaElement'

const HeaderSearchBoxStates = Object.freeze({
    CLOSED: 'closed',
    OPEN: 'open'
})

class HeaderSearchBox {
    constructor(element) {
        this.element = element

        if (!this.element) return

        this.state = HeaderSearchBoxStates.CLOSED

        this.init()
    }

    get id () {
        return this.element.id
    }

    get field() {
        return this.element.querySelector('input[type="search"]')
    }

    get toggle() {
        return document.querySelector(`[aria-controls="${this.id}"]`)
    }

    get isOpened () {
        return this.state === HeaderSearchBoxStates.OPEN
    }

    get panel () {
        return this.element.querySelector('[data-search-panel]')
    }

    init () {
        this.bindClick(this.toggle)
        this.bindEscapePress()
        this.handleClickOutside()
        this.bindTransitionEnd()
    }

    open () {
        this.state = HeaderSearchBoxStates.OPEN
        this.updateElement()
        this.updateToggle()
    }

    close () {
        this.state = HeaderSearchBoxStates.CLOSED
        this.updateElement()
        this.updateToggle()
    }

    bindClick (toggle) {
        if (!toggle) return
        toggle.addEventListener('click', this.handleClick.bind(this))
    }

    bindEscapePress () {
        document.addEventListener('keydown', (event) => this.handleEscapePress.bind(this)(event))
    }

    handleClickOutside () {
        document.addEventListener('click', (event) => {
            if (!this.isOpened) return

            const clickedInsidePanel = this.panel?.contains(event.target)
            const clickedToggle = this.toggle?.contains(event.target)

            if (clickedInsidePanel || clickedToggle) return

            this.close()
        })
    }

    bindTransitionEnd () {
        this.element.addEventListener('transitionend', this.handleTransitionEnd.bind(this))
    }

    handleClick () {
        this.isOpened ? this.close() : this.open()
    }

    handleEscapePress (event) {
        if (!this.isOpened) return
        if (event.key === 'Escape') this.close()
    }

    handleTransitionEnd () {
        if (this.isOpened) this.field?.focus()
        if (!this.isOpened) this.toggle?.focus()
    }

    updateToggle () {
        if (!this.toggle) return

        const toggle = new AriaElement(this.toggle)

        toggle.element.setAttribute('aria-expanded', this.isOpened ? 'true' : 'false')

        if (toggle.hasDynamicTitle) {
            toggle.titlePlaceholder.textContent = this.isOpened ? toggle.titleExpanded : toggle.titleNotExpanded
        }
    }

    updateElement () {
        this.isOpened
            ? this.element.classList.add('is-aria-expanded')
            : this.element.classList.remove('is-aria-expanded')
    }
}

export default HeaderSearchBox
